import { useEffect, useCallback } from 'react';

import { userActivity } from '@/services/service.user.activity';

const ACTIVITY_EVENTS = [
  'mousedown',
  'keydown',
  'mousemove',
  'scroll',
  'touchstart',
  'click',
  'focus',
  'input',
];

export const useActivityTracking = (onInactive: () => void) => {
  const handleActivity = useCallback(() => {
    userActivity.recordActivity();
  }, []);

  useEffect(() => {
    // Initial activity record
    handleActivity();

    // Add event listeners
    ACTIVITY_EVENTS.forEach((event) => {
      window.addEventListener(event, handleActivity, { passive: true });
    });

    // Periodic check for inactivity
    const checkInterval = setInterval(() => {
      if (!userActivity.isActive()) {
        onInactive();
      }
    }, 60000); // Check every minute

    return () => {
      ACTIVITY_EVENTS.forEach((event) => {
        window.removeEventListener(event, handleActivity);
      });
      clearInterval(checkInterval);
    };
  }, [handleActivity, onInactive]);
};
